import { observable, action, runInAction, decorate } from "mobx";
import OrdersLogApi from "./api";

class OrdersLogStore {
    rootStore;
    apiClient;

    orderId = undefined;
    list = [];
    total = 0;
    pageNumber = 1;
    pageSize = 500;

    isFetchingListInProgress = false;
    fetchingListError = undefined;

    constructor(rootStore) {
        this.rootStore = rootStore;
        this.apiClient = new OrdersLogApi(rootStore.apiClient);
    }

    async fetchList({ orderId, pageNumber, pageSize } = {}) {
        runInAction(() => {
            if (orderId !== undefined) this.orderId = orderId;
            if (pageNumber !== undefined) this.pageNumber = pageNumber;
            if (pageSize !== undefined) this.pageSize = pageSize;
            this.isFetchingListInProgress = true;
            this.fetchingListError = undefined;
        });
        try {
            const data = await this.apiClient.list(this.orderId, {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
            });
            runInAction(() => {
                this.list = data?.items || [];
                this.total = data?.total_count ?? 0;
                this.isFetchingListInProgress = false;
            });
        } catch (err) {
            runInAction(() => {
                this.list = [];
                this.total = 0;
                this.fetchingListError = err;
                this.isFetchingListInProgress = false;
            });
        }
    }
}

decorate(OrdersLogStore, {
    orderId: observable,
    list: observable,
    total: observable,
    pageNumber: observable,
    pageSize: observable,
    isFetchingListInProgress: observable,
    fetchingListError: observable,
    fetchList: action,
});

export default OrdersLogStore;
